module.exports = __webpack_public_path__ + "img/PRINT_BOOK.FR-Slider_02.12ad151f.jpg";